import React from 'react'
import WhiteRight from '../../../../media/felsv/white_right-arrow_icon.svg'
import {useHistory} from 'react-router'
import {State} from '../../../../reducers'
import {useDispatch, useSelector} from 'react-redux'
import {generalOpenModalError} from '../../../../actions/general.actions'
import {bindActionCreators} from 'redux'
import {actionComprobanteRetencionEmision} from '../../../../actions/action-creators'
import {comprobanteRetencionModalsOpenQuitarTodo} from '../../../../actions/comprobante-retencion/comprobanteRetencionProductos.actions'

const mensajeError = 'No existen documentos asociados para quitar.'

const CREFooter = () => {
  const history = useHistory()
  const documentosAsociados = useSelector((state: State) => state.comprobanteRetencion.documentosAsociados)
  const dispatch = useDispatch()
  const {comprobanteRetencionClicGenerarFactura, comprobanteRetencionGetUUID} = bindActionCreators(actionComprobanteRetencionEmision, dispatch)

  const generarFactura = async () => {
    if (await comprobanteRetencionClicGenerarFactura()) history.push('/otros-documentos/comprobante-retencion/resumen')
    comprobanteRetencionGetUUID()
  }

  const openModalQuitarTodo = () => {
    if (documentosAsociados.length === 0) return dispatch(generalOpenModalError(mensajeError))
    dispatch(comprobanteRetencionModalsOpenQuitarTodo())
  }

  return (
    <>
      <div style={{display: 'flex', gap: '6px', flexWrap: 'wrap', justifyContent: 'space-between', width: '100%', }}>
        <button className='m button transparent botton-footer' onClick={openModalQuitarTodo}><div>Quitar todo</div></button>
        <button className='m button botton-footer' onClick={generarFactura}>
          <div>Siguiente</div>
          <img src={WhiteRight} loading='lazy' alt='Generar' />
        </button>
      </div></>
  )
}

export default CREFooter
